import * as React from 'react';
import { axiosInstance } from '@/api/axiosInstance';

// Re-exported for existing call sites; the implementation lives in its own
// axios-free module so edge-safe code (apiRoutes → middleware) can import
// it without dragging axiosInstance into the Edge Runtime bundle.
export { buildQuery } from '@/api/buildQuery';

const fetchBody = (url: string): Promise<unknown> => (
  axiosInstance().get(url).then((r) => r.data)
);

// React's cache() memoises per server render, so generateMetadata, the
// layout and the page — which each run their own fetch*Props pass — share
// one round-trip per URL instead of one each. Next only dedupes native
// fetch() on its own; axios calls need this.
//
// `cache` only exists in the canary React that Next vendors for the App
// Router. Stable react@18 (Pages Router leftovers, vitest) has no such
// export, so fall back to the plain fetcher there. In the browser it's a
// passthrough, so React Query refetches are unaffected.
const dedupedFetchBody = typeof React.cache === 'function' ? React.cache(fetchBody) : fetchBody;

/**
 * Generic GET helper: fetch a URL via the project's configured axios
 * instance and resolve to the response body. Wraps the ubiquitous
 * `(await axiosInstance().get<T>(url)).data` pattern.
 *
 * Deduped on the URL alone. `_cacheKey` is a leftover from the mock-server
 * days (axiosInstance ignores it) and is kept only so existing call sites
 * compile; it must not take part in the dedupe key.
 */
export const get = <T>(url: string, _cacheKey?: string): Promise<T> => (
  dedupedFetchBody(url) as Promise<T>
);
